function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.5 1.5h6.25v7.75H2V3a1.5 1.5 0 011.5-1.5zm7.75 7.75V1.5h6.25A1.5 1.5 0 0119 3v6.25h-7.75zm-1.5 1.5v7.75H3.5A1.5 1.5 0 012 17v-6.25h7.75zM.5 3a3 3 0 013-3h14a3 3 0 013 3v14a3 3 0 01-3 3h-14a3 3 0 01-3-3V3zm11.75 10.25a.75.75 0 01.75-.75h4a.75.75 0 010 1.5h-4a.75.75 0 01-.75-.75zm0 2.5A.75.75 0 0113 15h4a.75.75 0 010 1.5h-4a.75.75 0 01-.75-.75zM6 2.75a.75.75 0 01.75.75v1.25H8a.75.75 0 110 1.5H6.75V7.5a.75.75 0 01-1.5 0V6.25H4a.75.75 0 010-1.5h1.25V3.5A.75.75 0 016 2.75zm7 2a.75.75 0 000 1.5h4a.75.75 0 000-1.5h-4zM3.97 16.53a.75.75 0 010-1.06l.97-.97-.97-.97a.75.75 0 111.06-1.06l.97.97.97-.97a.75.75 0 011.06 1.06l-.97.97.97.97a.75.75 0 11-1.06 1.06L6 15.562l-.97.97a.75.75 0 01-1.06 0z",
  fill: "currentColor"
});

function SvgCalculator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 20",
    fill: "none"
  }, props), _ref);
}

export default SvgCalculator;